import React from 'react';
import { useLocale } from '../../hooks/useLocale';
import { useStoreActions, useStoreState } from '../../store';
import { LanguageMenuScreen } from '../../store/languageMenu';
import { SubtitleTextWeights } from '../../typings';
import { Toggle } from '../Toggle';
import { MenuHeader } from './MenuHeader';
import { BoldTextRow, BoldTextStatus, NavRow, NavRowChevron, NavRowLabel, SubmenuScreenContent } from './styles';

export const OptionsScreen = () => {
  const locale = useLocale();
  const actions = useStoreActions((actions) => actions);
  const subtitleTextWeight = useStoreState((state) => state.subtitles.subtitleTextWeight);

  function handleWeightChange() {
    const { Bold, Regular } = SubtitleTextWeights;
    const weight = subtitleTextWeight === Bold ? Regular : Bold;

    actions.subtitles.setSubtitleTextWeight(weight);
    actions.settings.setSubtitleTextWeight(weight);
  }

  return (
    <SubmenuScreenContent>
      <MenuHeader
        title={locale.translations.LanguageOptions.SubtitleOptions}
        onBack={() => actions.languageMenu.navigateBack()}
      />
      <NavRow
        data-testid="videoPlayer_optionsFontSizeRow"
        onClick={() => actions.languageMenu.navigateTo(LanguageMenuScreen.FontSize)}
      >
        <NavRowLabel>{locale.translations.SubtitleOptions.FontSize}</NavRowLabel>
        <NavRowChevron />
      </NavRow>
      <NavRow
        data-testid="videoPlayer_optionsFontColorRow"
        onClick={() => actions.languageMenu.navigateTo(LanguageMenuScreen.FontColor)}
      >
        <NavRowLabel>{locale.translations.SubtitleOptions.FontColor}</NavRowLabel>
        <NavRowChevron />
      </NavRow>
      <BoldTextRow>
        <NavRowLabel>{locale.translations.SubtitleOptions.BoldText}</NavRowLabel>
        <BoldTextStatus>
          {subtitleTextWeight === SubtitleTextWeights.Bold
            ? locale.translations.General.On
            : locale.translations.General.Off}
        </BoldTextStatus>
        <Toggle
          active={subtitleTextWeight === SubtitleTextWeights.Bold}
          onClick={handleWeightChange}
          data-testid="videoPlayer_subtitleTextBoldCheckbox"
        />
      </BoldTextRow>
    </SubmenuScreenContent>
  );
};
